import { useColorPickerClipboard } from "client/hooks/utils/useColorpickerClipboard";
import { capitalize } from "client/utils/capitalize";
import { translateFunc } from "client/utils/translateFunc";
import { DEFAULT_TOAST_SHOW_TIME } from "components/common/Toast/ToastRenderer";
import { useToast } from "components/common/Toast/useToast";
import { useAppSelector } from "store/store";
import { ColorSchemeProps } from "./ColorScheme";

export const useColorScheme = (colors: ColorSchemeProps["colors"]) => {
    const source = useAppSelector((state) => state.colorPicker.source);
    const { handleCopy } = useColorPickerClipboard(source);
    const { toast } = useToast();
    const copiedToastText = capitalize(`${translateFunc("copied")}!`);

    const handleCopyAll = () => {
        if (!Array.isArray(colors)) return;
        handleCopy(colors.map((color) => color.hex).join(" "));
        toast({
            closeable: true,
            position: "top-right",
            status: "success",
            text: copiedToastText,
            time: DEFAULT_TOAST_SHOW_TIME,
        });
    };

    return {
        source,
        handleCopyAll,
    };
};
